import { v4 as uuidv4 } from 'uuid';
import { JsonFieldType } from '../../../types';
import { ComponentType, type IComponentSchema } from '../../types';
import type { IComponentProps } from './index';

export const generate = (
  props?: Partial<IComponentSchema<IComponentProps>>
): IComponentSchema<IComponentProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.VOID,
    name: props?.name || id,
    title: props?.title || 'Compare Workspace',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.CompareWorkspace,
    'x-component-props': {
      visible: true,
      rootNodes: {},
      nodes: undefined,
      modelInstanceId: undefined,
      height: 900,
      explorerDefaultExpanded: true,
      tagFilterEnabled: false,
      tagFilterShowMoreText: 'Show more',
      tagFilterShowLessText: 'Show less',
      enableDiff: false,
      enableComments: false,
      enableSummary: false,
      defaultView: 'redline',
      displayMode: 'modal',
      modalButtonText: 'Open Compare Workspace',
      modalButtonType: 'primary',
    },
    'x-component-props-config': {
      nodes: { type: 'variable' },
    },
  };
};
